import { createAction } from 'redux-actions';

import { TOS_UPDATED, IS_LOADING } from '../reducers/tos';
import { getTosUpdatedDate } from '../../firebase/tos';

const MILLISECONDS_IN_SIXTY_DAYS = 60 * 24 * 60 * 60 * 1000;

const setTosUpdated = createAction(TOS_UPDATED);
const setLoading = createAction(IS_LOADING);

export const isTosUpdated = () => async dispatch => {
    dispatch(setLoading(true));

    try {
        const tosUpdatedDate = await getTosUpdatedDate();

        dispatch(setTosUpdated(tosUpdatedDate && tosUpdatedDate + MILLISECONDS_IN_SIXTY_DAYS > Date.now()));
    } finally {
        dispatch(setLoading(false));
    }
};



// WEBPACK FOOTER //
// ./src/store/actions/tos.js